import * as React from 'react';
import { Dialog, DialogTitle, DialogContent, Grow, DialogActions, Button, Paper, Tabs, Tab } from '@material-ui/core';
import { TabPanel } from "../ui/tabs";
import { makeStyles } from '@material-ui/core/styles';
import CancelIcon from '@material-ui/icons/Cancel';
import SearchPlayers from './searchPlayers';
import { PlayersList } from './playersList';
const Transition = React.forwardRef((props, ref) => React.createElement(Grow, Object.assign({ in: props.in, timeout: 5500, ref: ref }, props)));
const useStyles = makeStyles({
    tabRoot: {
        flexGrow: 1,
    }
});
export const SelectPlayerPopup = props => {
    const [value, setValue] = React.useState(0);
    const cannotChoosePlayersTabPanelIndex = 99;
    const selectedTabValue = props.canChoosePlayers ? value : cannotChoosePlayersTabPanelIndex;
    const classes = useStyles();
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    const selectedPlayer = (player) => {
        props.selectedPlayer && props.selectedPlayer(player);
    };
    return (React.createElement(Dialog, { open: props.open, onClose: props.onClose, "aria-labelledby": "form-dialog-title", TransitionComponent: Transition, transitionDuration: 500, maxWidth: 'md', fullWidth: true },
        React.createElement(DialogTitle, { id: "form-dialog-title" }, "V\u00E6lg en spiller"),
        React.createElement(DialogContent, null,
            React.createElement(Paper, { className: classes.tabRoot },
                React.createElement(Tabs, { value: selectedTabValue, onChange: handleChange, indicatorColor: "primary", textColor: "primary", centered: true },
                    React.createElement(Tab, { label: "Hold", disabled: !props.canChoosePlayers }),
                    React.createElement(Tab, { label: "S\u00F8g", disabled: !props.canChoosePlayers }),
                    React.createElement(Tab, { label: "Opret", disabled: !props.canChoosePlayers })),
                React.createElement(TabPanel, { value: selectedTabValue, index: 0 },
                    React.createElement(PlayersList, { players: props.playersList, isLoading: false, selectedPlayer: selectedPlayer })),
                React.createElement(TabPanel, { value: selectedTabValue, index: 1 },
                    React.createElement(SearchPlayers, { selectedPlayer: selectedPlayer, matchData: props.matchData })),
                React.createElement(TabPanel, { value: selectedTabValue, index: 2 }),
                React.createElement(TabPanel, { value: selectedTabValue, index: cannotChoosePlayersTabPanelIndex }, "I denne kamp kan der kun v\u00E6lges spillere, som har deltaget i en tidligere kamp."))),
        React.createElement(DialogActions, null,
            React.createElement(Button, { onClick: props.onClose, variant: "outlined", color: "secondary", startIcon: React.createElement(CancelIcon, null) }, "Annuller"))));
};
